<template>
  <div class="container-fluid" style="padding: 0">
    <div class="row no-gutters app-header">
      <div class="col-lg-12">
        <AppHeader></AppHeader>
      </div>
    </div>
    <div id="main-content-view" class="row justify-content-md-center">
      <div class="col-lg-12">
        <Overlay></Overlay>
        <router-view></router-view>
      </div>
    </div>
    <div class="row rowMargin justify-content-end">
      <div class="col-4 text-right">
        Version 2.0. Released on January 16 2020.
      </div>
    </div>
   <notifications group="success"
                   :duration="6000"
                   animation-name="v-fade-left"
                   :width="450"
                   position="top right">
                   
       <template slot="body" slot-scope="props">
        <div class="success-template">
          <div class="success-template-icon">
             <img src="../src/assets/img/tick-inside-circle.svg" alt="Sucess" />
          </div>
          <div class="success-template-content">
            <div class="success-template-text"
                 v-html="props.item.text"></div>
          </div>
          <div class="success-template-close"
               @click="props.close">
            <i class="fa fa-fw fa-close"></i>
          </div>
        </div>
      </template>
    </notifications>

<notifications group="error"
                   :duration="6000"
                   animation-name="v-fade-left"
                   :width=500
                   position="top right">
       <template slot="body" slot-scope="props">
        <div class="error-template">
          <div class="error-template-icon">
            <img src="../src/assets/img/round-error-symbol.svg" alt="error" />
          </div>
          <div class="error-template-content">
            <div class="error-template-text"
                 v-html="props.item.text"></div>
          </div>
          <div class="error-template-close"
               @click="props.close">
            <i class="fa fa-fw fa-close"></i>
          </div>
        </div>
      </template>
    </notifications>

    <notifications group="warn"
                   :duration="6000"
                   animation-name="v-fade-left"
                   :width=450
                   position="top right">
       <template slot="body" slot-scope="props">
        <div class="warn-template">
          <div class="warn-template-icon">
             <img src="../src/assets/img/tick-inside-circle.svg" alt="warn" />
          </div>
          <div class="warn-template-content">
            <div class="warn-template-text"
                 v-html="props.item.text"></div>
          </div>
          <div class="warn-template-close"
               @click="props.close">
            <i class="fa fa-fw fa-close"></i>
          </div>
        </div>
      </template>
    </notifications>

     <notifications group="inprogress"
                   :duration="5000"
                   :width="450"
                   animation-name="v-fade-left"
                   position="top right">
       <template slot="body" slot-scope="props">
        <div class="inprogress-template">
          <div class="inprogress-template-icon">
            <img src="../src/assets/img/history-clock-button.svg" alt="Sucess" />
          </div>
          <div class="inprogress-template-content">
            <div class="inprogress-template-text"
                 v-html="props.item.text"></div>
          </div>
          <div class="inprogress-template-close"
               @click="props.close">
            <i class="fa fa-fw fa-close"></i>
          </div>
        </div>
      </template>
    </notifications>


  </div>  
</template>

<script>
import AppHeader from "./components/AppHeader";
import Overlay from "./components/Overlay";

export default {
  name: 'App',
  components: {
    AppHeader,
    Overlay
  }
}
</script>

<style scoped>
  .container-fluid {
    overflow: inherit;
    max-height: 100%;
    overflow-y: auto !important;
  }


 .success-template {
	 display: flex;
	 flex-direction: row;
	 flex-wrap: nowrap;
	 text-align: left;
	 font-size: 16px;
	 margin: 5px;
	 margin-bottom: 0;
	 align-items: center;
	 justify-content: center;
	 background: #dbf5e7;
	 border: 2px solid #0ea758;
}
 .success-template, .success-template > div {
	 box-sizing: border-box;
}
 .success-template .success-template-icon {
	 flex: 0 1 auto;
	 color: #137c4b;
	 font-size: 32px;
	 padding: 0 5px;
}
 .success-template .success-template-close {
	 flex: 0 1 auto;
	 padding: 0 20px;
	 font-size: 16px;
	 opacity: 0.2;
	 cursor: pointer;
}
 .success-template .success-template-close:hover {
	 opacity: 0.8;
}
 .success-template .success-template-content {
	 padding: 10px 10px 6px 5px;
	 flex: 1 0 auto;
}
 .success-template .success-template-content .success-template-text {
	 font-size: 16px;
   color:#08aa56
}


.inprogress-template {
	 display: flex;
	 flex-direction: row;
	 flex-wrap: nowrap;
	 text-align: left;
	 font-size: 13px;
	 margin: 5px;
	 margin-bottom: 0;
	 align-items: center;
	 justify-content: center;
	 background: #FDF7E5;
	 border: 2px solid #9E7E38;
}
 .inprogress-template, .inprogress-template > div {
	 box-sizing: border-box;
}
 .inprogress-template .inprogress-template-icon {
	 flex: 0 1 auto;
	 color: #9E7E38;
	 font-size: 32px;
	 padding: 0 5px;
}
 .inprogress-template .inprogress-template-close {
	 flex: 0 1 auto;
	 padding: 0 20px;
	 font-size: 16px;
	 opacity: 0.2;
	 cursor: pointer;
}
 .inprogress-template .inprogress-template-close:hover {
	 opacity: 0.8;
}
 .inprogress-template .inprogress-template-content {
   padding: 10px 10px 6px 5px;
	 flex: 1 0 auto;
}
 .inprogress-template .inprogress-template-content .inprogress-template-text {
	 font-size: 16px;
   color:#9E7E38
}

 .warn-template {
	 display: flex;
	 flex-direction: row;
	 flex-wrap: nowrap;
	 text-align: left;
	 font-size: 13px;
	 margin: 5px;
	 margin-bottom: 0;
   align-items: center;
	 justify-content: center;
	 background: #f8f4bb;
	 border: 2px solid #857d0f;
}
 .warn-template, .warn-template > div {
	 box-sizing: border-box;
}
 .warn-template .warn-template-icon {
	 flex: 0 1 auto;
	 color: #857d0f;
	 font-size: 32px;
	 padding: 0 5px;
}
 .warn-template .warn-template-close {
	 flex: 0 1 auto;
	 padding: 0 20px;
	 font-size: 16px;
	 opacity: 0.2;
	 cursor: pointer;
}
 .warn-template .warn-template-close:hover {
	 opacity: 0.8;
}
 .warn-template .warn-template-content {
   padding: 10px 10px 6px 5px;
	 flex: 1 0 auto;
   
}
 .warn-template .warn-template-content .warn-template-text {
	 font-size: 16px;
   color:#857d0f;
}

 .error-template {
	 display: flex;
	 flex-direction: row;
	 flex-wrap: nowrap;
	 text-align: left;
	 font-size: 13px;
	 margin: 5px;
	 margin-bottom: 0;
	 align-items: center;
	 justify-content: center;
	 background: #f1c9c9;
	 border: 2px solid #b82626;
}
 .error-template, .error-template > div {
	 box-sizing: border-box;
}
 .error-template .error-template-icon {
	 flex: 0 1 auto;
	 color: #b82626;
	 font-size: 32px;
	 padding: 0 5px;
}
 .error-template .error-template-close {
	 flex: 0 1 auto;
	 padding: 0 20px;
	 font-size: 16px;
	 opacity: 0.2;
	 cursor: pointer;
}
 .error-template .error-template-close:hover {
	 opacity: 0.8;
}
 .error-template .error-template-content {
	 padding: 10px 10px 6px 5px;
	 flex: 1 0 auto;
}
 .error-template .error-template-content .error-template-text {
	  font-size: 16px;
     color:#b82626;
}
.bottom-fixed{
    position: absolute;
    right: 20px;
    bottom: 10px;
}

.rowMargin {
  margin-right: 0px;
  margin-right: 0px;
}

</style>

